import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function Terms() {
  return (
    <div className="min-h-screen relative pt-20">
      <div className="container mx-auto px-4 py-8 relative z-10 max-w-4xl">
        <Card className="glass-default border-white/10">
          <CardHeader>
            <CardTitle className="text-4xl font-bold gradient-text">Terms of Service</CardTitle>
            <p className="text-white/60">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Agreement to Terms</h2>
              <p className="text-white/80 leading-relaxed">
                By accessing and using RazientSounds, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Use of Platform</h2>
              <p className="text-white/80 leading-relaxed mb-4">
                RazientSounds provides a platform connecting event organizers with professional artists. By using our service, you agree to:
              </p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account</li>
                <li>Not engage in fraudulent or illegal activities</li>
                <li>Respect intellectual property rights</li>
                <li>Comply with all applicable local, state, and federal laws</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Bookings and Inquiries</h2>
              <p className="text-white/80 leading-relaxed mb-4">
                <strong>For Users:</strong> RazientSounds is a free artist roster. When you send a booking inquiry, a team-managed conversation is opened between you, the artist and RazientSounds staff to coordinate dates, logistics and terms. RazientSounds does not process payments on the platform.
              </p>
              <p className="text-white/80 leading-relaxed mb-4">
                <strong>For Artists:</strong> By creating an artist profile, you agree to honor confirmed bookings and provide professional services as advertised.
              </p>
              <p className="text-white/80 leading-relaxed">
                <strong>Cancellations:</strong> If plans change, notify us in your booking conversation as early as possible so we can reschedule or cancel with all parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Artist Verification</h2>
              <p className="text-white/80 leading-relaxed">
                All artist profiles are subject to admin approval. We reserve the right to reject or remove any artist profile that violates our terms or quality standards.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Fees</h2>
              <p className="text-white/80 leading-relaxed">
                RazientSounds does not charge booking fees or commissions. Optional in-app purchases inside the Virtual Nightclub (such as VibeCoins items, outfits and furniture) are cosmetic and clearly priced before purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Prohibited Activities</h2>
              <p className="text-white/80 leading-relaxed mb-4">Users may not:</p>
              <ul className="list-disc list-inside text-white/80 space-y-2">
                <li>Harass, threaten, or intimidate other users — in chats, live streams or the virtual club</li>
                <li>Upload malicious content or viruses</li>
                <li>Impersonate others or provide false information</li>
                <li>Scrape or collect data from the platform</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Intellectual Property</h2>
              <p className="text-white/80 leading-relaxed">
                Artists retain ownership of their uploaded content but grant RazientSounds a license to display and promote their profiles. The RazientSounds platform, logo, and design are protected by copyright and trademark laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Limitation of Liability</h2>
              <p className="text-white/80 leading-relaxed">
                RazientSounds acts as a platform connecting users and artists. We are not responsible for the quality of performances, disputes between parties, or any damages arising from bookings. Our liability is limited to the amount paid for the specific booking in question.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Dispute Resolution</h2>
              <p className="text-white/80 leading-relaxed">
                Any disputes arising from the use of RazientSounds shall be resolved through binding arbitration. Users waive the right to participate in class action lawsuits.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Changes to Terms</h2>
              <p className="text-white/80 leading-relaxed">
                We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Contact Information</h2>
              <p className="text-white/80 leading-relaxed">
                For questions about these Terms of Service, please contact us at support@razientsounds.com
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
